//
// Utility Plugin for setting the configuration
//
import { pluginFactory } from './utils/plugins';
export var BVConfigPlugin =
/*#__PURE__*/
pluginFactory();


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/bv-config.js
// module id = ./node_modules/bootstrap-vue/esm/bv-config.js
// module chunks = 1